import { Box, ClickAwayListener } from '@mui/material'
import PopupSection from 'components/popup/PopupSection'
import { ReactNode } from 'react'
import { COLORS } from 'utils/colors'
import { useAddGroup } from './addGroup/AddGroupProvider'

import * as Styled from './styled'
import GroupcalTooltip from 'components/tooltips/GroupcalTooltip'
import { t } from 'i18next'
import { GenericColor } from 'assets/icons'

interface ColorsPopupInterface {
  color?: string
  setColor: (color: string) => void
  selector?: ReactNode
  open?: boolean
  setOpen: (b: boolean) => void
  size?: number
  showGenericIcon?: boolean
}

function ColorsPopupContent(props: ColorsPopupInterface) {
  return (
    <PopupSection>
      <Styled.ColorsPopupContent>
        {COLORS.map((color) => (
          <Styled.ColorsPopupColor
            id={color.replace('#', '')}
            key={color}
            style={{ backgroundColor: color }}
            onClick={() => {
              props.setColor(color)
              props.setOpen(false)
            }}
          />
        ))}
      </Styled.ColorsPopupContent>
    </PopupSection>
  )
}

export default function ColorsPopup(props: ColorsPopupInterface) {
  const openPopup = () => {
    props.setOpen(true)
  }
  return (
    <Styled.ColorsPopup
      open={props.open}
      setOpen={props.setOpen}
      placement="bottom"
      content={<ColorsPopupContent {...props} />}
    >
      {props.selector ?? (
        <div>
          <GroupcalTooltip title={t('setCalendarColor')}>
            {props.showGenericIcon ? (
              <Box sx={{ cursor: 'pointer' }} id="group-color-button">
                <img
                  onClick={openPopup}
                  style={{ maxWidth: 40, maxHeight: 40 }}
                  src={GenericColor}
                />
              </Box>
            ) : (
              <Styled.ColorsPopupSelector
                sx={{ width: props.size, height: props.size }}
                onClick={openPopup}
                color={props.color}
              />
            )}
          </GroupcalTooltip>
        </div>
      )}
    </Styled.ColorsPopup>
  )
}
